import { MessageSquare, Sparkles, Users } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateEscalatingToTheRightTeamAr: TemplateAr = {
  name: 'أتمتة التصعيد إلى الفريق المناسب بالذكاء الاصطناعي',
  description:
    'تصعيد ذكي يوجّه المشاكل المعقّدة للفرق المتخصصة حسب محتوى التذكرة وإلحاحها والخبرة المطلوبة.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'مشكلة معقّدة' },
    { icon: Sparkles, label: 'الـ AI يحلل' },
    { icon: Users, label: 'تصعيد', final: true },
  ],
  detailDescription: {
    paragraph1:
      'صعّد التذكرة للفريق المتخصص، مو للطابور العام. الـ AI يكتشف المشكلة التقنية المعقّدة، والاستثناء من السياسة، والمسألة القانونية، والموقف عالي المخاطر اللي يتطلب خبيراً. ويحلل سجل المحادثة وشريحة العميل ودرجة تعقيد المشكلة، عشان يشغّل تصعيداً ذكياً بسياق كامل.',
    paragraph2:
      'قرارات التصعيد وسياقها ومسار توجيهها تلقاها في نظام التذاكر عندك، وتوصل لقادة الفرق عبر Slack أو الإيميل. والنظام يتتبّع أنماط التصعيد ونتائج المعالجة عشان يحسّن قرارات التوجيه القادمة. ومقاييس التصعيد تغذّي لوحات الأداء وأدوات تخطيط الطاقة الاستيعابية.',
  },
  benefits: [
    'المشكلة المعقّدة توصل للخبير من أول مرة',
    'زمن استجابة التصعيد ينزل',
    'فريق التصعيد يشوف السياق كامل',
    'ما في تذكرة تبقى في الطابور الغلط',
    'تشوف أنماط التصعيد واتجاهاته',
    'فرقك المتخصصة تاخذ اللي يستاهل',
  ],
};
